import { Modal } from '@app/app/_components/Modal/Modal';
import { ReactNode } from 'react';

interface Props {
    isLoginOpen: boolean;
    isSelectClientOpen: boolean;
    handleLoginClose: () => void;
    handleSelectClientClose: () => void;
    loginWidget: ReactNode;
    selectClientWidget: ReactNode;
    canClose?: boolean;
}

export function LoginModalSection({
    isLoginOpen,
    isSelectClientOpen,
    handleLoginClose,
    handleSelectClientClose,
    loginWidget,
    selectClientWidget,
    canClose = false,
}: Props) {
    return (
        <>
            <Modal cardClassName="gap-8 p-8 md:min-w-dialog" open={isLoginOpen} onClose={handleLoginClose}>
                {loginWidget}
            </Modal>

            <Modal
                cardClassName="gap-8 p-8 md:min-w-dialog"
                open={isSelectClientOpen}
                onClose={handleSelectClientClose}
                canClose={canClose}>
                {selectClientWidget}
            </Modal>
        </>
    );
}
